import React from "react"

import PageCirclesComponent from "./PageCircles"

export const PageCircles = props => {
  return <PageCirclesComponent {...props} />
}

export default PageCircles

/**
 * @todo:
 *  [ ] presets / defaults [1]
 *  [ ] attribute which can hide at some breakpoints
 *  [ ] option to change size at breakpoints
 *  [x] relative positioning so you can have multiple items that just go down the page
 *
 * 1) presets could be as easy as components with settings already set; see the CircleBurstsSet etc.
 * */
